import React from 'react';
import { Box, Button } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

const ActionButtons = ({ canEdit, project, bulkActionMode, onAddRoom, onAddWorkArea, onAddItem, onToggleBulk }) => (
  <Box display="flex" gap={2} mb={3}>
    <Button
      variant="outlined"
      startIcon={<AddIcon />}
      onClick={onAddRoom}
      disabled={!canEdit}
    >
      Add Room
    </Button>
    <Button
      variant="contained"
      startIcon={<AddIcon />}
      onClick={onAddWorkArea}
      disabled={!canEdit || !project?.rooms || project.rooms.filter(r => r.type === 'room').length === 0}
    >
      Add Work Area
    </Button>
    <Button
      variant="outlined"
      startIcon={<AddIcon />}
      onClick={onAddItem}
      disabled={!canEdit || !project.rooms || project.rooms.length === 0}
    >
      Add Item
    </Button>
    <Button
      variant={bulkActionMode ? 'contained' : 'outlined'}
      color="primary"
      onClick={onToggleBulk}
    >
      {bulkActionMode ? 'Cancel Bulk Select' : 'Bulk Select'}
    </Button>
  </Box>
);

export default ActionButtons;
